export default {"src":"/_next/static/media/organmeat.4d3a4071.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};